module.exports = __webpack_public_path__ + "img/1500833878.ef7ab079.jpg";